import type { FullActivityItem } from '@customTypes/types';
import { Box, Stack, Title } from '@mantine/core';

import styles from './BoardCol.module.css';

export const BoardCol = ({
  colTitle,
  data,
  onSelectItem,
  renderItem: RenderItem
}: {
  colTitle: string;
  data: FullActivityItem[];
  onSelectItem: (activityItem: FullActivityItem) => void;
  renderItem: React.ComponentType<{
    task: FullActivityItem;
    onClick: () => void;
  }>;
}) => (
  <Stack className={styles.container}>
    <Box className={styles.title}>
      <Title order={4} tt='capitalize'>
        {colTitle}
      </Title>
    </Box>
    <Stack>
      {data.map((item: FullActivityItem, index) => (
        <RenderItem
          key={index}
          task={item}
          onClick={() => onSelectItem(item)}
        />
      ))}
    </Stack>
  </Stack>
);
